module.exports = __webpack_public_path__ + "static/media/pilot_exploitation.4c64ba8d.png";